import { ISSRPageData } from '@interfaces'
import { ObjectService } from '@services'
import { ObjectTemplate } from '@templates'
import { createNavLink } from '@utils'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

const ArtArchivesWorkDetailScreen = ({ pageData, global }: ISSRPageData) => {
  const { locale } = useRouter()
  const { t } = useTranslation()

  return (
    <ObjectTemplate
      pageData={pageData}
      global={global}
      headerLeftNavButtonLabel={t('nav:archives')}
      headerLeftNavButtonHref={
        pageData.data?.sourceId?.value && pageData.slug
          ? `${createNavLink('archives', locale)}/${
              pageData.slug
            }#collection-${pageData.data.sourceId.value}`
          : createNavLink('archives', locale)
      }
    />
  )
}

export default ArtArchivesWorkDetailScreen

/**
 * slug is collection sourceId
 * object is object of collection sourceId
 */
interface ISSRProps {
  query: {
    slug: string
    object: string
  }
  locale: string
}

export async function getServerSideProps({ query, locale }: ISSRProps) {
  const { object, slug } = query
  const pageData = {
    data: null,
    error: null,
    slug: null,
  }

  try {
    const collection = await ObjectService.getObjectDetailPage(
      object,
      locale,
      'archive',
      slug
    )

    pageData.data = collection
    pageData.slug = slug
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  if (!pageData.data && !pageData.error) {
    pageData.error = { message: 'Object not found' }
  }

  return {
    props: { pageData },
  }
}
